export const userTypeMapper = {
  s: {
    name: "seller",
    title: "Supplier",
  },
  b: {
    name: "buyer",
    title: "Buyer",
  },
}
